/**
 * Password validation rules matching the Cognito User Pool password policy.
 *
 * Pool policy: minLength: 8, requireLowercase, requireDigits.
 * No uppercase or symbol requirement.
 */
export function getPasswordRules(value) {
    const trimmed = value.trim();
    return [
        { id: "length", label: "At least 8 characters", valid: value.length >= 8 },
        { id: "lowercase", label: "At least one letter", valid: /[a-z]/i.test(value) },
        { id: "digit", label: "At least one number", valid: /\d/.test(value) },
        { id: "spaces", label: "No leading or trailing spaces", valid: trimmed === value },
    ];
}
